import { post, post_customer, get_customer } from '@/http';
import qs from 'qs';
/**
 * 获取公众号配置
 */
export function getOfficialAccountsConfig(data) {
  return post({
    url: `/beijing-zone-member/fficialAccounts/getOfficialAccountsConfig`,
    data,
    hasLoading: true,
  });
}

/**
 * 获取临时token
 */
export function oauthToken() {
  return post_customer({
    url: `/beijing-auth-iam-customer/oauth/token`,
    data: qs.stringify({
      grant_type: 'client_credentials',
      scope: 'h5_scope',
    }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    hasLoading: true,
  });
}

/**
 * 获取凭证
 */
export function getAuthToken(params) {
  return get_customer({
    url: `/beijing-auth-iam-customer/users/getAuthToken`,
    params,
    hasLoading: true,
  });
}

/**
 * 获取用户的车辆列表
 */
export function getUserVehicleList() {
  return get_customer({
    url: `/beijing-info-vehicle/exterior/h5/vehicle/user`,
  });
}

/**
 * 获取经销商省市区树
 * @return {Promise<void>}
 */
export function getDealerAreaData() {
  return get_customer({
    url: '/beijing-info-vehicle/exterior/h5/dealer/getYunYangDealerAreaTree',
  });
}

/**
 * 根据经纬度获取距离最近的经销商信息
 * @param {number | string} latitude
 * @param {number | string} longitude
 * @param {'1'|'2'|'3'} dealerType 类别 1电车 2油车 3双授权
 * @returns {Promise<{data: {dealerName: string, address: string, comments: number, feedbackRate: string, city: string, dealerSn: string, latitude: string, typeName: string, pid: number, type: number, rid: number, dis: number, fullTimeHotLine: string, province: string, grade: number, district: string, logo: string, id: string, salesHotLine: null, longitude: string, cid: number}}>}
 */
export function getNearestDealerInfoByGeo({ latitude, longitude, dealerType = '3' }) {
  return get_customer({
    url: '/beijing-info-vehicle/wxApp/dealer/neareatDealerByType',
    params: { latitude, longitude, dealerType },
  });
}

/**
 * 个人中心-个人详情
 */
export function getPersonalDetail(params) {
  return get_customer({
    url: '/beijing-zone-member/userCustomer/getPersonalDetail',
    params,
  });
}

/**
 * 获取客服配置
 */
export function getZoneCustomerServiceDetail(params) {
  return get_customer({
    url: '/beijing-info-configure/applet/zoneCustomerService/selectExteriorAppletDetail',
    params,
  });
}
